import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SignupService } from '@app/_services';

@Component({
  selector: 'app-partner-email',
  templateUrl: './partner-email.component.html',
  styleUrls: ['./partner-email.component.css']
})
export class PartnerEmailComponent implements OnInit {

  emailForm: UntypedFormGroup;
  loading: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
    private signupService: SignupService) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(){
    this.emailForm = this.formBuilder.group({
      partnerID: ['', [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    });
  }

  onSubmit(){
    var id = this.emailForm.value.partnerID * 1;
    this.signupService.sendPartnerEmail(id).subscribe();
  }

}
